/**
 * 启动诊断器（零依赖，必须最先执行）。
 *
 * 作用：当 React/antd 彻底崩溃、连 ErrorBoundary 兜底 UI 都无法渲染、
 * #root 被卸载为空、页面纯白屏时，把真实错误直接以原生 DOM 打到页面上，
 * 让用户/我们无需打开 DevTools 就能看到根因。
 *
 * 仅在发生【未被捕获】的错误时才写页面；正常渲染时 React 会占据 #root，不受影响。
 */
(function installBootDiagnostics() {
    if (typeof window === 'undefined') return;
    if (window.__BOOT_DIAG_INSTALLED__) return;
    window.__BOOT_DIAG_INSTALLED__ = true;

    // 已知的良性噪声，忽略之（不代表页面崩溃）
    const BENIGN = /ResizeObserver loop|ResizeObserver loop completed|Script error\.?$/i;

    function esc(s) {
        return String(s).replace(/[<>&]/g, function (c) { return { '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]; });
    }

    function paint(kind, err) {
        try {
            const root = document.getElementById('root');
            if (!root) return;
            // 若 React 已经渲染出内容（#root 有元素子节点），不要覆盖正常页面
            const hasRealContent = root.querySelector && root.querySelector('*');
            if (hasRealContent && !window.__BOOT_DIAG_PAINTED__) {
                // React 有内容说明这次错误未致命，交给 React/ErrorBoundary 处理
                return;
            }
            const msg = (err && (err.stack || err.message)) || String(err);
            window.__BOOT_DIAG_PAINTED__ = true;
            // i18n 可能还没加载：按 cookie locale / 浏览器语言只分中文和英文两种
            const lang = ((document.cookie.match(/(?:^|; )locale=([^;]*)/) || [])[1] || navigator.language || '').toLowerCase();
            const zh = lang.indexOf('zh') === 0;
            root.innerHTML =
                '<div style="min-height:100vh;background:#f5f5f5;padding:48px 16px;box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,\'Segoe UI\',Roboto,sans-serif;display:flex;justify-content:center;align-items:flex-start">'
                + '<div style="width:100%;max-width:820px;background:#fff;border:1px solid #ffccc7;border-radius:10px;padding:24px;box-shadow:0 2px 12px rgba(0,0,0,.06)">'
                + '<div style="font-size:20px;font-weight:600;color:#cf1322;margin-bottom:8px">' + (zh ? '页面加载失败' : 'Page failed to load') + '</div>'
                + '<div style="color:#595959;margin-bottom:16px;font-size:14px">' + (zh ? '应用启动时发生了未捕获的错误（' + esc(kind) + '）。请把下面这段红字截图发给我们即可定位。' : 'An uncaught error occurred while the app was starting (' + esc(kind) + '). Send us a screenshot of the red text below so we can find the cause.') + '</div>'
                + '<pre style="white-space:pre-wrap;word-break:break-word;font-size:12px;color:#a8071a;background:#fff1f0;border:1px solid #ffa39e;border-radius:6px;padding:12px;max-height:420px;overflow:auto;margin:0 0 16px">' + esc(msg) + '</pre>'
                + '<button onclick="window.location.reload()" style="padding:6px 16px;border-radius:6px;border:1px solid #1677ff;background:#1677ff;color:#fff;cursor:pointer;font-size:14px">' + (zh ? '刷新页面' : 'Reload page') + '</button>'
                + '</div></div>';
        } catch (e) { /* noop */ }
    }

    window.addEventListener('error', function (e) {
        const m = (e && (e.message || (e.error && e.error.message))) || '';
        if (BENIGN.test(m)) return;
        paint('error', (e && e.error) || m);
    });
    window.addEventListener('unhandledrejection', function (e) {
        const reason = e && e.reason;
        const m = (reason && (reason.message || String(reason))) || '';
        if (BENIGN.test(m)) return;
        paint('promise', reason || m);
    });
})();
